const SEARCH_ENDPOINTS = {
  // Search
  FILTER_CITY: "/frontend/filter-city",
  GET_CITY_DETAILS: "/frontend/city-details",
  GET_SCHOOL_DETAILS: "/frontend/get-school-information",
  PUBLIC_GET_SCHOOL_DETAILS: "/public/get-school-information",
  CHECK_FILTER_CITY: "/frontend/check-filter-city-count",
  CHECK_CITY_SEARCH: "/frontend/check-city-search-count",
  SEARCH_SESSION_ID: "/frontend/search-analytics/session/start",
  SEARCH_ANALYTICS: "/frontend/search-analytics/track/filter",
  TRACK_SEARCH_CITY_CLICK: "/frontend/search-analytics/track/city-click",
  SEARCH_SESSION_END: "/frontend/search-analytics/session/end",
  SEARCH_BOOKMARK: "/frontend/city-bookmarks/toggle",
  CHECK_MULTIPLE_BOOKMARKS: "/frontend/city-bookmarks/check-multiple",
  GET_BOOKMARKS: "/frontend/city-bookmarks",
  CITY_AUTOCOMPLETE: "/frontend/city-autocomplete",
  MORTGAGE_CITY_DATA: "/frontend/mortgage-city-data",
  CITY_SPOTLIGHT: "/frontend/city-spotlight",
};

export default SEARCH_ENDPOINTS;
